/**
 * 생성 조건 — 막대 위 요약 칩과 그 칩이 여는 조건 고르기. 넓은 화면은 위로 뜨는 2단 메뉴, 좁은 화면은
 * 「문제 설정」 바텀시트(PRD 3-4). 여기선 표시 방식만 고르고, 각 방식이 자기 칩·열림을 소유한다.
 */
import { formatAiGenerateDockConditionsSummary } from '../utils/aiGenerateDockConditionsSummary';
import { AiGenerateDockConditionsMenu, type AiGenerateDockConditionsMenuProps } from './AiGenerateDockConditionsMenu';
import { AiGenerateDockConditionsSheet } from './AiGenerateDockConditionsSheet';
export type AiGenerateDockConditionsFieldProps = Omit<AiGenerateDockConditionsMenuProps, 'summary'> & {
  presentation?: 'menu' | 'sheet';
};
export const AiGenerateDockConditionsField = ({
  presentation = 'menu',
  ...props
}: AiGenerateDockConditionsFieldProps) => {
  const summary = formatAiGenerateDockConditionsSummary(props.copy, props.conditions, props.countState.count);
  if (presentation === 'sheet') {
    return <AiGenerateDockConditionsSheet copy={props.copy} open={props.open} onOpenChange={props.onOpenChange} conditions={props.conditions} countOptions={props.countState.options} onSave={props.onConditionsChange} summary={summary} disabled={props.disabled} />;
  }
  return <AiGenerateDockConditionsMenu {...props} summary={summary} data-sentry-element="AiGenerateDockConditionsMenu" data-sentry-component="AiGenerateDockConditionsField" data-sentry-source-file="AiGenerateDockConditionsField.tsx" />;
};